const IP_RIGHT_TYPE = ['All IP types', 'Trademarks', 'Designs', 'PATENTS'];

const filters = {
    trademark: [
        {
            globalsKey: 'requestNames',
            filterid: 'requestNames',
            name: 'requestNames',
            placeholder: 'user.type',
            filterOptions: [],
            multiple: true,
        },
        {
            globalsKey: 'modalities',
            filterid: 'modality',
            name: 'modality',
            placeholder: 'current.status',
            filterOptions: [],
            multiple: true,
        },
    ],
    design: [
        {
            globalsKey: 'requestNames',
            filterid: 'requestNames',
            name: 'requestNames',
            placeholder: 'request.name',
            filterOptions: [],
            multiple: true,
        },
        {
            globalsKey: 'modalities',
            filterid: 'modality',
            name: 'modality',
            placeholder: 'modality',
            filterOptions: [],
            multiple: true,
        },
        {
            filterid: 'dateIntervalDraft',
            name: 'dates',
            placeholder: 'date',
        },
    ],
    impersonation: [
        {
            globalsKey: 'userType',
            filterid: 'userType',
            name: 'userType',
            placeholder: 'user.type',
            filterOptions: [],
            multiple: true,
        },
        {
            globalsKey: 'userStatus',
            filterid: 'userStatus',
            name: 'userStatus',
            placeholder: 'current.status',
            filterOptions: [],
            multiple: true,
        },
    ],
};

const trademarksActionOptions = [
    'TM Renewal',
    'TM Transfer',
    'TM Change Owner Details',
    'TM Change Rep/Corr details',
    'TM Generic',
    'TM License Contract',
    'TM Rights in rem',
];

const initiateActions = {
    trademarks: trademarksActionOptions,
    designs: [...trademarksActionOptions, 'TM Withdrawal/Surrender', 'TM Limit G&S'],
};

const getInitiateActions = (category) => initiateActions[category] || [];

const getDropDownFilters = (category) => filters[category] || [];

export default {
    getDropDownFilters,
    getInitiateActions,
};
